/**
 * useNotifications — real-time notification feed for the current user
 */
import { collection, query, where, orderBy, limit, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import useAuth from '../auth/useAuth';
import useFirestoreSnapshot from './useFirestoreSnapshot';

/** Only show notifications from the last 30 days */
const NOTIFICATION_WINDOW_DAYS = 30;

const useNotifications = () => {
  const { user } = useAuth();
  const result = useFirestoreSnapshot(
    () => {
      if (!user?.uid) return null;
      const cutoff = Timestamp.fromDate(
        new Date(Date.now() - NOTIFICATION_WINDOW_DAYS * 24 * 60 * 60 * 1000)
      );
      return query(
        collection(db, 'activityLog'),
        where('userId', '==', user.uid),
        where('createdAt', '>', cutoff),
        orderBy('createdAt', 'desc'),
        limit(50)
      );
    },
    [user?.uid]
  );

  const valid = (result.data || []).filter((n) => n.title || n.message);
  const unreadCount = valid.filter((n) => !n.read).length;

  return { ...result, unreadCount };
};

export default useNotifications;
